import { GetApiData, getJsonAsync } from './fetchConfig';

export const useCountries = () => GetApiData('countries');

export const getAllCountries = () => getJsonAsync('countries');
